import React, { useEffect, useRef } from 'react';

import styles from './Avatar.module.scss';
import { motion, useAnimation, useInView } from 'framer-motion';


const Avatar = ({src, primary = false, width = 200}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const mainControls = useAnimation();

    useEffect(() => {
        if (isInView) {
            mainControls.start("visible");
        }
    }, [isInView]);

    return (
        <div ref={ref}>
            <div className={`${styles.avatar}`}>
                <img alt="avatar-img" src={src} width={width} />
                {primary && <div className={styles.primaryBorder} />}
            </div>
        </div>
    )
}

export default Avatar;